import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { ILocalization, LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';

import { SearchResultsStore } from 'stores/search-results-store';
import { ViewTracker } from 'stores/contexts/viewTracker';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from 'components/search/map/map-preview';
import { parse } from 'query-string';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';

export interface SidebarProps extends RouteComponentProps {
  searchResults?: SearchResultsStore;
  l10n?: ILocalization;
  withFilters?: boolean;
  tracker: IClickstreamAnalytics;
  viewTracker: ViewTracker;
}
type LocalizedSidebarProps = SidebarProps & LocalizedComponentProps;

// @ts-ignore
@withLocalization
@inject('searchResults')
@observer
class SidebarComponent extends React.Component<LocalizedSidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null,
    withFilters: true,
  };

  // eslint-disable-next-line complexity
  public render() {
    const { searchResults, withFilters, tracker, viewTracker } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const group = searchCriteria && searchCriteria.group;
    const { l10n, location } = this.props;
    const formatText = l10n?.formatText;

    const sortAndFilterOptions: SortAndFilterModel = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.options;
    const pwaMapOverlay = Boolean(parse(location.search).pwaOverlay === 'map');
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;

    return (
      <section data-stid="desktop-sidebar">
        <MapPreview viewTracker={viewTracker} tracker={tracker} />
        {shouldShowSidebar && withFilters && (
          <>
            <h2 className="is-visually-hidden">{formatText && formatText('hotels.searchResults.filtersDialog.title')}</h2>
            {!pwaMapOverlay && (
              <UitkSpacing padding={{ blockend: 'twelve' }}>
                <UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTERS} />
              </UitkSpacing>
            )}
          </>
        )}
      </section>
    );
  }
}

export const Sidebar = withRouter(SidebarComponent);
